import {
  useAnchorClickMessageDispatcher,
  useModalMessageDispatcher,
  usePageReadyDispatcher
} from './dispatchers';

/**
 * This hook dispatches messages to the native app.
 */

export default function useNativeMessageDispatcher(
  shouldSendPageReady: boolean,
  hasValidSoftPull: boolean
) {
  useAnchorClickMessageDispatcher();
  useModalMessageDispatcher();
  usePageReadyDispatcher(shouldSendPageReady, hasValidSoftPull);
}
